"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AccordionButton, Box, useMultiStyleConfig } from "@chakra-ui/react";
import AccordionChevron from "./AccordionChevron";
const AccordionTitle = ({ children }) => {
    const styles = useMultiStyleConfig("Accordion");
    return (_jsxs(AccordionButton, { children: [_jsx(Box, Object.assign({ as: "span", sx: styles.title, pr: "3" }, { children: children })), _jsx(AccordionChevron, {})] }));
};
AccordionTitle.displayName = "AccordionTitle";
export default AccordionTitle;
//# sourceMappingURL=AccordionTitle.js.map